export enum SCREEN_TYPES {
  LOGO = "LOGO",
  LOGIN = "LOGIN",
  DASHBOARD = "DASHBOARD"
}
